import API from "./api";

const AdminNotesService = {
  // ============ TOPIC/FOLDER MANAGEMENT ============

  // Get all topics/folders (flat or filtered)
  getTopics: async (courseId = null, parentId = null, contentType = null) => {
    try {
      let url = "/admin/notes/topics";
      const params = [];
      if (courseId) params.push(`course_id=${courseId}`);
      if (parentId !== null) params.push(`parent_id=${parentId}`);
      if (contentType) params.push(`content_type=${contentType}`);
      if (params.length) url += `?${params.join("&")}`;
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching topics:", error);
      throw error;
    }
  },

  // Get hierarchical structure for a course
  getHierarchy: async (courseId) => {
    try {
      const response = await API.get(`/admin/notes/hierarchy/${courseId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching hierarchy:", error);
      throw error;
    }
  },

  // Get single topic/folder with all content
  getTopic: async (id) => {
    try {
      const response = await API.get(`/admin/notes/topics/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching topic:", error);
      throw error;
    }
  },

  // Create topic or folder
  createTopic: async (data) => {
    try {
      const response = await API.post("/admin/notes/topics", data);
      return response.data;
    } catch (error) {
      console.error("Error creating content:", error);
      throw error;
    }
  },

  // Update topic/folder
  updateTopic: async (id, data) => {
    try {
      const response = await API.put(`/admin/notes/topics/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating content:", error);
      throw error;
    }
  },

  // Delete topic/folder
  deleteTopic: async (id) => {
    try {
      const response = await API.delete(`/admin/notes/topics/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting content:", error);
      throw error;
    }
  },

  // Move topic/folder to different parent
  moveTopic: async (id, parentId) => {
    try {
      const response = await API.post(`/admin/notes/move/${id}`, {
        parent_id: parentId,
      });
      return response.data;
    } catch (error) {
      console.error("Error moving content:", error);
      throw error;
    }
  },

  // ============ BLOCK MANAGEMENT ============

  addBlock: async (data) => {
    try {
      const response = await API.post("/admin/notes/blocks", data);
      return response.data;
    } catch (error) {
      console.error("Error adding block:", error);
      throw error;
    }
  },

  updateBlock: async (id, data) => {
    try {
      const response = await API.put(`/admin/notes/blocks/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating block:", error);
      throw error;
    }
  },

  deleteBlock: async (id) => {
    try {
      const response = await API.delete(`/admin/notes/blocks/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting block:", error);
      throw error;
    }
  },

  // ============ EXERCISE MANAGEMENT ============

  addExercise: async (data) => {
    try {
      const response = await API.post("/admin/notes/exercises", data);
      return response.data;
    } catch (error) {
      console.error("Error adding exercise:", error);
      throw error;
    }
  },

  updateExercise: async (id, data) => {
    try {
      const response = await API.put(`/admin/notes/exercises/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating exercise:", error);
      throw error;
    }
  },

  deleteExercise: async (id) => {
    try {
      const response = await API.delete(`/admin/notes/exercises/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting exercise:", error);
      throw error;
    }
  },
  // ============ IMPORT FROM COURSE ============

  importFromCourse: async (data) => {
    try {
      const response = await API.post("/admin/notes/import", data);
      console.log("Import API response:", response);

      // Return the response data directly
      return response.data;
    } catch (error) {
      console.error("Error importing from course:", error);
      throw error;
    }
  },
};

export default AdminNotesService;
